import type { Allergen, DietaryConcernReason, DietaryTag } from '../../shared/menu';
import type { OnboardingChoice } from './store';

export interface IdentityCard {
  choice: OnboardingChoice;
  label: string;
  hint: string;
}

// The identity options shown in Splash onboarding and re-pickable in Settings.
// Order matters — most safety-critical first, "none" last.
export const IDENTITY_CARDS: IdentityCard[] = [
  { choice: 'medical', label: 'I have a medical allergy', hint: 'Reaction risk — anaphylaxis, hospital visit' },
  { choice: 'celiac', label: 'I have celiac disease', hint: 'Strict no gluten + cross-contamination' },
  { choice: 'halal', label: 'I keep halal', hint: 'No pork, no alcohol, halal-slaughtered meat' },
  { choice: 'kosher', label: 'I keep kosher', hint: 'No pork, no shellfish, kosher rules' },
  { choice: 'non_medical', label: "I don't eat certain foods", hint: 'Vegan, vegetarian, ethical, preference' },
  { choice: 'none', label: 'Nothing right now', hint: 'Just translate the menu' },
];

export interface IdentityDefaults {
  allergens: Allergen[];
  dietary: DietaryTag[];
  reason: DietaryConcernReason | null;
}

// Defaults applied when the user picks an identity (in onboarding or re-picks
// in Settings). Halal/kosher/celiac auto-set the relevant hard-filter
// allergens AND the dietary flag so the menu filter (2.2) can surface
// "halal-friendly only" / "kosher-friendly only" / "vegan only" pills.
export function defaultsFor(choice: OnboardingChoice): IdentityDefaults {
  switch (choice) {
    case 'medical':
      return { allergens: [], dietary: [], reason: 'medical' };
    case 'celiac':
      return { allergens: ['wheat'], dietary: ['gluten_free'], reason: 'celiac' };
    case 'halal':
      return { allergens: ['pork', 'alcohol'], dietary: ['halal'], reason: 'halal' };
    case 'kosher':
      return { allergens: ['pork', 'shellfish'], dietary: ['kosher'], reason: 'kosher' };
    case 'non_medical':
      return { allergens: [], dietary: [], reason: 'ethical' };
    case 'none':
      return { allergens: [], dietary: [], reason: null };
  }
}
